import BooleanEditor from "./BooleanEditor.js";
import IntEditor from "./IntEditor.js";
import StringEditor from "./StringEditor.js";
import TimestampEditor from "./TimestampEditor.js";
import ComponentTypesEditor from "./ComponentTypesEditor.js";
import FotaItemSelector from "./fotaItemSelector/PluginSetup.js";
import FotaItemMultiSelector from "./fotaItemMultiSelector/PluginSetup.js";
import FirmwareComponentsSelector from "./firmwareComponentsSelector/PluginSetup.js";
import FotaAttrValueOptions from "./fotaAttrValueOptions/PluginSetup.js";
import DeviceGroupsSelector from "./deviceGroupsSelector/PluginSetup.js";
import StartTimeEditor from "./StartTimeEditor.js";
import EnumEditor from "./EnumEditor.js";
import { install } from "./PluginSetup.js";
import LazyObjectEditor from "./LazyObjectEditor.js";
export default {
  BooleanEditor,
  IntEditor,
  ObjectEditor: LazyObjectEditor,
  StringEditor,
  TimestampEditor,
  ComponentTypesEditor,
  FotaItemSelector,
  FotaItemMultiSelector,
  FirmwareComponentsSelector,
  FotaAttrValueOptions,
  DeviceGroupsSelector,
  StartTimeEditor,
  EnumEditor,
  install
};